import { ethers } from 'ethers';
import { RoyaltyPoolContractAddress } from "../constants/config";




const getContract =async () => {
  if(window.ethereum){
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const contractABI = require("../constants/RoyaltyPoolContract.json");
    const contract = new ethers.Contract(RoyaltyPoolContractAddress, contractABI, signer);
    return contract
  }    
}

export default getContract